export const GlossarioPaginaUrl: string = "http://contou-hom.tempus.digital/glossario-da-contabilidade/";
export const ArquivosSomenteImagem = [".jpeg", ".jpg", ".png"];
export const ArquivosSomentePdf = [".pdf"];
export const ArquivosGeral = [".pdf", ".xls", ".jpeg", ".jpg", ".png", ".csv", ".doc", ".docx", ".pfx",".xml"];